<div class="app-peripheral-topic-item" (click)="onBlockClick(content)" [ngClass]="{'active': content?.isActive}">
  <mat-card>
    <mat-card-title-group>
      <mat-card-title *ngIf="content?.title" class="fs-6 text-black-50">{{ content?.title | titlecase }}
      </mat-card-title>

    </mat-card-title-group>
    <mat-card-content class="d-grid">
      <div class="d-flex align-items-center space-between"> <small class="status-{{ content?.status?.type }}"
          matTooltip="Status: {{ content?.status?.title | uppercase }}" [matTooltipPosition]="'above'">
          {{ content?.status?.title | uppercase }}
        </small>
        <img [ngClass]="{'opacity-50' : !content?.isRecognized}" [src]="content?.icon"
          alt="{{ content?.id | titlecase }}" matTooltip="{{ content?.id | titlecase }}"
          [matTooltipPosition]="'above'" />
      </div>
      <ng-container *ngIf="!content?.isRecognized">
        <small class="text-right not-recognized">{{ MESSAGES?.NOT_RECOGNIZED }}</small>

      </ng-container>

    </mat-card-content>
  </mat-card>
</div>
